<template>
    <div class="container">
        <md-dialog :md-active.sync="modalCrear" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.calificacion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="calificacion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.score}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="score" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="descripcion" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarCalificacion">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import Calificacion from '../../../services/Calificacion';
export default {
    name : 'Crear',
    props : ['modalCrear','infoVigencia'],
    data : () => ({
        // vigencia : '',
        calificacion : '',
        score : null,
        descripcion : '',
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear Calificación',
                    vigencia : 'Vigencia',
                    calificacion : 'Calificación',
                    score : 'Score',
                    descripcion : 'Descripción',
                    save : 'Guardar',
                    close : 'Cerrar'
                }
            }else{
                return {
                    title : 'Create Rating',
                    vigencia : 'Validity',
                    calificacion : 'Rating',
                    score : 'Score',
                    descripcion : 'Description',
                    save : 'Save',
                    close : 'Close'
                }
            }
        }
    },
    methods:{
        guardarCalificacion(){
            let dataForm = [
                // this.vigencia,
                this.descripcion,
                this.calificacion,
                this.score
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                
                let info = {
                    'vigencia'      : this.infoVigencia,
                    'calificacion'  : this.calificacion,
                    'score'         : this.score,
                    'descripcion'   : this.descripcion,
                    'idUser'        : this.$store.state.userId
                }

                Calificacion.createCalificacion(info)
                .then((res) => {
                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location.reload()
                    }
                })
                .catch((err) => {
                    if(err.response.status == 400){
                        this.$toast.error(err.response.data.message)
                    }
                })
            }
        },
        cierraModal(){
            this.$emit('cierraModal',false)
        }
    }
}
</script>

<style>

</style>